import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import querystring from "query-string";

import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";

import { kycStatuses } from "../../store/constants";
import { dateFormatter, kycStatusFormatter } from "../../util/formatter";
import desktop from "../../api/users";
import reports from "../../api/reports";

class DesktopUser extends Component {
  table = React.createRef();

  state = {
    kyc: "ALL",
  };

  headerStyle = {
    backgroundColor: "#D15050",
    color: "white",
  };

  handleInputChange = event => {
    this.setState(
      {
        kyc: event.target.value,
      },
      () => {
        this.handleFilterClick();
      },
    );
  };

  handleFilterClick = () => {
    const { history, location } = this.props;

    const newQueryParams = {};

    if (this.state.kyc) {
      newQueryParams.kyc = this.state.kyc;
    }

    const oldSearchQuery = querystring.parse(location.search);
    const newSearchQuery = querystring.stringify({
      ...oldSearchQuery,
      ...newQueryParams,
    });

    history.push({
      ...location,
      search: newSearchQuery,
    });
  };

  loadPagination = (page = 0, size = 10, filter = "", sort = "") => {
    const { kyc } = querystring.parse(this.props.location.search);
    return desktop.getAllDesktopUser(page, size, filter, sort, kyc);
  };

  componentDidMount() {
    const { kyc } = querystring.parse(this.props.location.search);

    if (kyc) {
      this.setState({ kyc });
    }
  }

  viewFormatter = (cell, row) => (
    <Link
      to={{
        pathname: `/kyc_info/${row.accountId}`,
        state: { data: row },
      }}>
      <div>
        <i className="fa fa-search" style={{ color: "#D15050" }} />
      </div>
    </Link>
  );

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Desktop Users</CardHeader>
              <CardBody>
                <Form
                  inline
                  style={{
                    marginBottom: ".5rem",
                    justifyContent: "flex-end",
                  }}>
                  <FormGroup
                    className="mb-2 mr-sm-2 mb-sm-0"
                    style={{ paddingRight: "2rem", alignItems: "baseline" }}>
                    <Label htmlFor="kyc" style={{ marginRight: "1rem" }}>
                      <h6>KYC Status:</h6>
                    </Label>
                    <Input
                      type="select"
                      name="kyc"
                      id="kyc"
                      value={this.state.kyc}
                      onChange={this.handleInputChange}>
                      {Object.keys(kycStatuses).map(key => {
                        return (
                          <option value={key} key={key}>
                            {kycStatuses[key].statusDesc}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Form>
                <TableContainerWithLocation
                  loadData={this.loadPagination}
                  requestReport={reports.requestAllDesktopUser}
                  wrappedComponentRef={innerComponent => {
                    // Forwarding ref to TableContainerWithLocationWithLocation through 'withRouter' HOC
                    // This is the only way to forward ref with React Router 4
                    if (innerComponent) {
                      this.table = innerComponent;
                    }
                  }}>
                  <BootstrapTable
                    headerStyle={this.headerStyle}
                    version="4"
                    search
                    pagination
                    striped
                    hover
                    condensed
                    remote
                    exportCSV>
                    <TableHeaderColumn
                      dataFormat={this.viewFormatter}
                      dataField="id"
                      width="60"
                      dataAlign="center">
                      View
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="organizationName"
                      width="200"
                      isKey>
                      Organisation
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="accountId"
                      width="100">
                      Account ID
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataField="primaryContact"
                      width="120">
                      Primary Contact
                    </TableHeaderColumn>
                    <TableHeaderColumn dataSort dataField="address" width="100">
                      Address
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataFormat={dateFormatter}
                      dataSort
                      dataField="createdTime"
                      width="140">
                      Registered Date
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataSort
                      dataFormat={kycStatusFormatter}
                      dataField="kycStatus"
                      width="140">
                      Status
                    </TableHeaderColumn>
                  </BootstrapTable>
                </TableContainerWithLocation>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DesktopUser;
